<template>
  <div class="d-content3">
    <!-- 轮播 -->
    <div class="lunbo" v-if="$route.meta.banner">
      <a-carousel dotsClass="dot" autoplay>
        <div v-for="(item,i) in banner" :key="i">
          <a :href="item.link"><img :src="'http://'+item.image_file"></a>
        </div>
      </a-carousel>
    </div>
    <!-- 产品下载 -->
    <div class="download main-center">
      <div class="main-font30 main-bg1 title text-center" slot="tabBarExtraContent">{{$t('title.qtwj')}}</div>
      <div class="tabs">
        <a-tabs @change="callback" tabPosition="left" :tabBarGutter="1">
          <a-tab-pane v-for="(item,i) in DownloadClass" :key="i" :tab="[$store.state.langStates == 'zh' ? item.category_name:item.category_name_en]">
            <div class="info float-left" v-for="(ditem,i) in DownloadList" :key="i">
              <div class="one">
                <span class="main-font20 font-bold">{{ditem.name}}{{ditem.name_en}}</span>
              </div>
              <div class="two main-font16">
                <div style="min-width: 80px;">{{$t('title.wjsm')}}：</div>
                <div class="line_sl">
                  <a-popover :title="$t('title.wjsm')">
                    <template slot="content">
                      <p style="width: 300px;word-wrap:break-word;">{{ditem.remark}}{{ditem.remark_en}}</p>
                    </template>
                    <span>{{ditem.remark}}{{ditem.remark_en}}</span>
                  </a-popover>
                </div>
              </div>
              <div class="line"></div>
              <div class="three">
                <span style="color: #999;">{{$t('title.fbsj')}}：{{ditem.updated_at}}</span>
                <a :href="'http://' + ditem.software_file" @click.prevent="downloadItem(ditem.software_file)">{{$t('title.wjxz')}} </a>
              </div>
            </div>
            <div class="clear"></div>
          </a-tab-pane>
        </a-tabs>
      </div>
      <div id="components-pagination-demo-mini">
        <a-pagination size="small" :total="info.total" :show-total="total => `${$t('title.total')} ${info.last_page} ${$t('title.pages')}`" :defaultPageSize="6" @change="onChange"/>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
export default {
  data() {
    return {
      DownloadClass:'',
      DownloadList:'',
      info:{
							last_page:0
						},
      name:'',
      name_en:'',
      banner:''
    };
  },
  created() {
    this.init(this.$store.state.langStates)
  },
  watch: {
    "$route": {
      handler(route) {
        const that = this
        if (route.name === '/download') {
          that.init(that.$store.state.langStates)
        }
      }
    },
    '$store.state.langStates': function(val) {
      this.init(val)
    }
  },
  methods: {
    callback(key) {
      var lang = this.$store.state.langStates
      if(lang=='zh'){
        this.id = this.DownloadClass[key].id
        this.name = this.DownloadClass[key].category_name
        this.name_en = ""
        this.getList(lang,1)
      }else{
        this.id = this.DownloadClass[key].id
        this.name = this.DownloadClass[key].category_name_en
        this.name_en = this.DownloadClass[key].category_name_en
        this.getList(lang,1)
      }
    },
    init(lang){
      this.$api.dongjuapi.category(lang).then(res=>{
        this.DownloadClass = res.data.data
        if(this.$store.state.langStates=='zh'){
          this.name = res.data.data[0].category_name
          this.name_en = ""
        }else{
          this.name = res.data.data[0].category_name_en
          this.name_en = res.data.data[0].category_name_en
        }
        this.id = res.data.data[0].id
        this.getList(lang,1)
      }).catch(err=>{

      })
      // 获取banner
      this.$api.dongjuapi.banner({
        type:'download'
      }).then(res=>{
        if(res.data.code==200){
          this.banner = res.data.data
        }
      })
    },
    onChange(current){
      this.getList(this.$store.state.langStates,current)
    },
    // 下载列表
    getList(lang,p){
      this.$api.dongjuapi.software({
          en:lang,
          name:this.name,
          category_id:this.id,
          limit:6,
          page:p,
          type:2
        }).then(r=>{
        this.info = r.data.data
        this.DownloadList = r.data.data.data
      }).catch(err=>{

      })
    },
    downloadItem(url){
      var d_url = 'http://' + url
			console.log(d_url)
			window.open(d_url)
      // axios.get(d_url,{responseType: 'blob' }).then(({data})=>{
      //   let blob = new Blob([data], { type: 'application/vnd.ms-excel' })
      //   let link = document.createElement('a')
      //   link.href = window.URL.createObjectURL(blob)
      //   link.download = url.split('/').pop()
      //   link.click()
      // }).catch(err=>{
      //   console.log(err)
      // })
    }
  },
};
</script>
<style lang="less">
  .d-content3{
    .ant-tabs .ant-tabs-left-content{
      padding-left: 20px;
    }
    .download{
      width: 1380px;
      padding: 80px 0;
      position: relative;
      .title{
        width: 260px;
        height: 100px;
        line-height: 100px;
        border: 1px solid rgba(255, 255, 255, 0);
        position: absolute;
        top: 80px;
      }
      .ant-tabs-left-bar {
        padding-top: 100px;
      }
      .ant-tabs{
        color: #101010;
      }
      .ant-tabs .ant-tabs-left-bar,.ant-tabs-left-content{
        border: none;
      }
      .ant-tabs-tab {
        width: 261px;
        background: #fff;
        text-align: left !important;
        padding: 15px 50px !important;
      }
      .ant-tabs-ink-bar{
        width: 0 !important;
      }
      .ant-tabs-nav .ant-tabs-tab-active{
        background: #bbb;
        color: #1E2986;
      }
    }
    .tabs{
      .info{
        width: 540px;
        height: 236px;
        background: #fff;
        margin-right: 20px;
        margin-bottom: 20px;
        overflow: hidden;
        &:nth-child(2n+1){
          margin-right: 0 !important;
        }
        >div{
          padding: 0 30px;
        }
        .one{
          padding-top: 20px;
          padding-bottom: 30px;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
        .two{
          height: 60px;
          display: flex;
          justify-content: flex-start;
          .line_sl{
            width: 400px;
            word-wrap:break-word;
            span{
              overflow : hidden;
              text-overflow: clip;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
            }
          }
        }
        .line{
          width: 540px;
          height: 1px;
          background: #E1E1E1;
          margin-top: 20px;
        }
        .three{
          height: 80px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          a{
            width: 100px;
            height: 30px;
            line-height: 30px;
            background: #746CAF;
            color: #fff;
            text-align: center;
            border-radius: 2px;
          }
        }
      }
    }
    #components-pagination-demo-mini{
      text-align: right;
      margin-top: 40px;
      margin-bottom: 40px;
      .ant-pagination-item-active{
        background: #746CAF;
        color: #fff;
        a{
          color: #fff;
        }
      }
    }
  }
</style>
